export default "__VITE_ASSET__DCnbDOnR__"